//메인화면 메뉴리스트
import React, { useState, useEffect } from "react";

//MUI
import { InputAdornment,  MenuItem,  TextField } from '@mui/material';
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { theme } from '../../assets/themes';
import USelectBox from "../../components/mui/USelectBox";

import { API } from "../../config";
import { fni18n } from "../../services/commonService";
import {
    getAPI
} from "../../services/commonService";
import AuthenticationService from "../../pages/auth/AuthenticationService";
const userLoginId = AuthenticationService.getLoggedInUserID();
const TillModify = (props) => {
    const [groups, setGroups] = useState([]);
    const [branchs, setBranch]=useState([]);
    const [storeNo, setStoreNo] = useState([]);
    const [select, setSelect] = useState({
        storeCd : "N/A",
        brandCd : "N/A",
    });
    const modify = props.data
    const total = props.total
    const Dtotal = Number(modify.cnt100D*100+modify.cnt50D*50+modify.cnt20D*20+modify.cnt10D*10+modify.cnt5D*5+modify.cnt1D*1).toLocaleString('en-US');
    const Ctotal = modify.cnt25C*0.25+modify.cnt10C*0.1+modify.cnt5C*0.05+modify.cnt1C*0.01;
    const onParamsChange = props.onParamsChange
    const onStoreChage = props.onStoreChage
    const onItemChage = async(e) =>{
        const {name, value} = e.target;
        setSelect({
            ...select,
            [name] :value,
        })
        if(name=='storeCd'){
            await loadComboBoxStoreNo(value);
        }
    }
    //화면 로드 시
    useEffect(() => {
        const getLoadData = async () => {
        try {
            if(modify.chkCreate ==""){
                await loadComboBoxGroup();
                await loadComboBoxBranch();
            }
        } catch (e) {
        }
        };
        getLoadData();
    }, []);

    useEffect(() => {
        let e;
        if(select.storeCd!="N/A" && modify.chkCreate ==""){
            if(select.brandCd!="N/A" && modify.chkCreate ==""){
                e = {
                    storeCd :{
                        name:'storeCd',
                        value:select.storeCd,
                    },
                    brandCd :{
                        name:'brandCd',
                        value:select.brandCd,
                    }
                }
            }else if(modify.chkCreate ==""){
                e = {
                    storeCd :{
                        name:'storeCd',
                        value:select.storeCd,
                    },
                    brandCd :{
                        name:'brandCd',
                        value:'',
                    }
                }
            }
        }else if(modify.chkCreate ==""){
            e = {
                storeCd :{
                    name:'storeCd',
                    value:'',
                },
                brandCd :{
                    name:'brandCd',
                    value:'',
                }
            }
        }else {
            e = {
                storeCd :{
                    name:'storeCd',
                    value:modify.storeCd,
                },
                brandCd :{
                    name:'brandCd',
                    value:modify.brandCd,
                }
            }
        }
        onStoreChage(e)
    }, [select]);
    // 콤보박스 데이터
    const loadComboBoxGroup = async () => {
        try{
            const res = await getAPI(API.COMMON.USER_GROUP);
            const _inputData = res.data.result.map((m) => ({
                    cd: m.grpCd,
                    name: m.grpNm,
                })
            );
            setGroups(_inputData );
        }catch(e){
            console.error(e.message);
        }
    }; 
    const loadComboBoxBranch = async () => {
        try{
            const res = await getAPI(API.COMMON.BRANCH, { userId: userLoginId });
            const _inputData = res.data.result.map((m) => ({
                    cd: m.storeCd,
                    name: m.storeNm,
                })
            );
            setBranch(_inputData );
            if (_inputData.length > 0){
                await loadComboBoxStoreNo(_inputData[0].cd);
            }
        }catch(e){
            console.error(e.message);
        }
    };
    const loadComboBoxStoreNo = async (branch) => {
        try{
            const res = await getAPI(API.COMMON.BRAND, { userId: userLoginId, branch: branch });
            const _inputData = res.data.result.map((m) => ({
                    cd: m.brandCd,
                    name: m.brandNm,
                })
            );
            if (_inputData.length > 0) {
                setSelect({
                    ...select,
                    ['brandCd'] : _inputData[0].cd,
                    ['storeCd'] : branch,
                })
            } else {
                setSelect({
                    ...select,
                    ['brandCd'] : "N/A",
                    ['storeCd'] : branch,
                })
            }
            setStoreNo(_inputData );
        }catch(e){
            console.error(e.message);
        }
    }
    return(
        <div className="pop-container">
            {/* 상단메뉴명 */}
            <div className="header">
                {fni18n('그룹별 준비금 설정')}
            </div>
            <div className="contents">
            <TableContainer className="table-container">
                <Table className="table" size="small">
                    <TableBody>
                        <TableRow>
                            <TableCell className="table-cell-title">{fni18n('지점')}</TableCell>
                            <TableCell className="table-cell">
                                {modify.chkCreate =="" && 
                                    <FormControl size="small" fullWidth>
                                    {/* <Select
                                        name="storeCd"
                                        onChange={onItemChage}
                                    >
                                        {branchs.map((map)=>(
                                            <MenuItem key={map.cd} value={map.cd}>
                                                {map.name}
                                            </MenuItem>
                                        ))}
                                    </Select> */}
                                    <USelectBox id="storeCd" name="storeCd" items={branchs} onItemChange={onItemChage} defaultValue={select.storeCd}/>
                                    </FormControl>
                                }
                                {modify.chkCreate !="" && 
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="storeNm"
                                        value={modify.storeNm}
                                        disabled
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        onChange={onParamsChange}
                                        variant="outlined" />
                                }
                            </TableCell>
                            <TableCell className="table-cell-title">{fni18n('브랜드')}</TableCell>
                            <TableCell className="table-cell">
                                {modify.chkCreate =="" && 
                                    <FormControl size="small" fullWidth>
                                    {/* <Select
                                        name="brandNm"
                                        onChange={onParamsChange}
                                    >
                                        {storeNo.map((map)=>(
                                            <MenuItem key={map.name} value={map.name}>
                                                {map.name}
                                            </MenuItem>
                                        ))}
                                    </Select> */}
                                        <USelectBox
                                            id="brandCd"
                                            name="brandCd"
                                            items={storeNo}
                                            onItemChange={onItemChage}
                                            defaultValue={select.brandCd}
                                        />
                                    </FormControl>
                                }
                                {modify.chkCreate !="" && 
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="brandNm"
                                        value={modify.brandNm}
                                        disabled
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        onChange={onParamsChange}
                                        variant="outlined" />
                                }
                            </TableCell>
                            <TableCell className="table-cell-title">{fni18n('사용자그룹')}</TableCell>
                            <TableCell className="table-cell">
                                {modify.chkCreate =="" && 
                                    <FormControl size="small" fullWidth>
                                    <Select
                                        name="grpNm"
                                        value={modify.grpNm}
                                        onChange={onParamsChange}
                                    >
                                        {groups.map((map)=>(
                                            <MenuItem key={map.name} value={map.name}>
                                                {map.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    </FormControl>
                                }
                                {modify.chkCreate !="" && 
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="grpNm"
                                        value={modify.grpNm}
                                        disabled
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        onChange={onParamsChange}
                                        variant="outlined" />
                                }
                            </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="table-cell-title">{fni18n('1일출금한도')}</TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="dayLimtAmt"
                                value={total.dayLimtAmt.toFixed(2)||0}
                                disabled
                                InputProps={{
                                    readOnly: true,
                                    inputProps: {style:{textAlign:"right"}},
                                    startAdornment:<InputAdornment position="start">$</InputAdornment>,
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                        <TableCell className="table-cell-title">{fni18n('1회출금한도')}</TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="tranctAmt"
                                value={total.tranctAmt.toFixed(2)||0}
                                disabled
                                InputProps={{
                                    readOnly: true,
                                    inputProps: {style:{textAlign:"right"}},
                                    startAdornment:<InputAdornment position="start">$</InputAdornment>,
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                    </TableRow>
                    </TableBody>
                </Table>
                </TableContainer >
                <TableContainer className="table-container">
                <Table className="table" size="small">
                    <TableBody>
                    <TableRow>
                        <TableCell className="table-cell-title" colSpan={7}>{fni18n('지폐')}</TableCell>
                        <TableCell className="table-cell-title" colSpan={5} >{fni18n('동전')}</TableCell>
                        <TableCell className="table-cell-title" rowSpan={2} >{fni18n('1일출금횟수')}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="table-cell-title">{fni18n('$100')}</TableCell>
                        <TableCell className="table-cell-title">{fni18n('$50')}</TableCell>
                        <TableCell className="table-cell-title">{fni18n('$20')}</TableCell>
                        <TableCell className="table-cell-title">{fni18n('$10')}</TableCell>
                        <TableCell className="table-cell-title">{fni18n('$5')}</TableCell>
                        <TableCell className="table-cell-title">{fni18n('$1')}</TableCell>
                        <TableCell className="table-cell-title">${fni18n('합계')}</TableCell>

                        <TableCell className="table-cell-title">{fni18n('25¢')}</TableCell>
                        <TableCell className="table-cell-title">{fni18n('10¢')}</TableCell>
                        <TableCell className="table-cell-title">{fni18n('5¢')}</TableCell>
                        <TableCell className="table-cell-title">{fni18n('1¢')}</TableCell>
                        <TableCell className="table-cell-title">¢{fni18n('합계')}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="cnt100D"
                                value={modify.cnt100D||0}
                                type="number"
                                required
                                InputProps={{
                                    inputProps: {min: 0, style:{textAlign:"center", paddingLeft:0, paddingRight:0}}
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="cnt50D"
                                value={modify.cnt50D||0}
                                type="number"
                                required
                                InputProps={{
                                    inputProps: {min: 0, style:{textAlign:"center", paddingLeft:0, paddingRight:0}}
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="cnt20D"
                                value={modify.cnt20D||0}
                                type="number"
                                required
                                InputProps={{
                                    inputProps: {min: 0, style:{textAlign:"center", paddingLeft:0, paddingRight:0}}
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="cnt10D"
                                value={modify.cnt10D||0}
                                type="number"
                                required
                                InputProps={{
                                    inputProps: {min: 0, style:{textAlign:"center", paddingLeft:0, paddingRight:0}}
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="cnt5D"
                                value={modify.cnt5D||0}
                                type="number"
                                required
                                InputProps={{
                                    inputProps: {min: 0, style:{textAlign:"center", paddingLeft:0, paddingRight:0}}
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="cnt1D"
                                value={modify.cnt1D||0}
                                type="number"
                                required
                                InputProps={{
                                    inputProps: {min: 0, style:{textAlign:"center", paddingLeft:0, paddingRight:0}}
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="Dtotal"
                                value={Dtotal}
                                disabled
                                InputProps={{
                                    readOnly: true,
                                    inputProps: {style:{textAlign:"center", paddingLeft:3, paddingRight:0}},
                                    // startAdornment:<InputAdornment position="start" sx={{m:0}}>$</InputAdornment>,
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="cnt25C"
                                value={modify.cnt25C||0}
                                type="number"
                                required
                                InputProps={{
                                    inputProps: {min: 0, style:{textAlign:"center", paddingLeft:0, paddingRight:0}}
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="cnt10C"
                                value={modify.cnt10C||0}
                                type="number"
                                required
                                InputProps={{
                                    inputProps: {min: 0, style:{textAlign:"center", paddingLeft:0, paddingRight:0}}
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="cnt5C"
                                value={modify.cnt5C||0}
                                type="number"
                                required
                                InputProps={{
                                    inputProps: {min: 0, style:{textAlign:"center", paddingLeft:0, paddingRight:0}}
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="cnt1C"
                                value={modify.cnt1C||0}
                                type="number"
                                required
                                InputProps={{
                                    inputProps: {min: 0, style:{textAlign:"center", paddingLeft:0, paddingRight:0}}
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="Ctotal"
                                value={Ctotal.toFixed(2)}
                                disabled
                                InputProps={{
                                    readOnly: true,
                                    inputProps: {style:{textAlign:"center", paddingLeft:3, paddingRight:0}},
                                    // endAdornment:<InputAdornment position="end" sx={{m:0}}>¢</InputAdornment>,
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="dayLimtCnt"
                                value={modify.dayLimtCnt||0}
                                type="number"
                                required
                                InputProps={{
                                    inputProps: {min: 0, style:{textAlign:"center"}}
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                    </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            </div>
        </div>
    );
}

export default TillModify;
